<template>
  <AccessHandler
    :requiredRoleGroups="[UdbApplicationGroup]"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div data-cy="ukd-companies-page">
    <MasterPage>
      <template v-slot:content>
        <header v-if="hasAccess" class="page__header--container clearfix">
          <h1 class="page__title--text" data-cy="ukd-companies-page-title">
            UKD SEARCH BY COMPANY
          </h1>
          <p data-cy="ukd-companies-page-text">
            Click PDF to Print OU Company Kosher of Certificate (LOC)
          </p>
        </header>
        <CompaniesTable v-if="hasAccess" />
        <GlobalFooter><div class="legalese"></div> </GlobalFooter>
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import CompaniesTable from "./CompaniesTable.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "../GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { UdbApplicationGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";

const main = useMainStore();

main.UkdCompanyFilterCriteria =
  new URLSearchParams(window.location.search).get("search") ?? "";

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
header.page-header {
  background: #eef4f6;
  padding: 30px 30px 20px;
  margin: 0;
  border: none;
  @media only screen and (min-width: 740px) {
    display: flex;
  }
}

.header-text {
  color: #3a5da6;
  font-size: 22px;
  font-weight: bold;
  margin-right: 40px;
  .results-label {
    font-size: 14px;
    display: block;
    font-weight: normal;
    color: #444;
  }
}
.header-input {
  flex: 1;
  max-width: 800px;
  position: relative;
  .search-icon {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  input {
    width: 100%;
    height: 50px;
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.05);
    &:focus {
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
      border-color: #3a5da6;
    }
  }
}
.clear-input {
  display: block;
  margin-top: 10px;
  cursor: pointer;
  color: #666;
  text-decoration: underline;
}
.page-container {
  padding: 30px 30px 60px;
  background: white;
  min-height: 100%;
  @media only screen and (min-width: 740px) {
    display: flex;
  }
  .sidebar {
    flex: 1;
    max-width: 350px;
    margin: 0;
    padding: 0;
    margin-right: 40px;
  }
  .main-content {
    flex: 3;
  }
}

.result-item {
  margin-bottom: 20px;
  display: flex;
  box-shadow: 0 0 35px rgb(0 0 0 / 10%);
}
.result-main {
  flex: 3;
  padding: 20px;
  > header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
  }
  .location {
    color: #999;
    margin-left: 10px;
    margin-top: 3px;
    span:not(:last-child):after {
      content: ",";
    }
  }
  .description {
    display: flex;
  }
}

section.no-results {
  text-align: center;
  padding-top: 40px;
  color: #666;
}

/* tooltip */
.help-tooltip {
  position: relative;
  display: inline-block;
  z-index: 10;
}
.fa-question-circle {
  font-size: 16px;
  display: block;
  line-height: 30px;
  color: #399cd3;
  cursor: pointer;
}
.fa-question-circle:hover ~ .tooltip-content {
  display: block;
}
.tooltip-content {
  display: none;
  background: #ffffe8;
  position: absolute;
  left: 20px;
  top: 3px;
  padding: 10px 15px;
  width: 300px;
  border: 1px solid #e4e4d5;
  border-radius: 4px;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 10%);
  font-size: 14px;
  font-weight: normal;
  color: #222;
}
.legalese {
  flex: 1;
  text-align: left;
  color: #999;
  padding: 10px 40px;
  border-top: 1px solid #eee;
  font-size: 12px;
}
</style>
